import { FiFlag, FiEdit2, FiTrash2 } from "react-icons/fi"

export default function SavedPriorityBox({
  priority,
  onEdit,
  onDelete
}: {
  priority: any
  onEdit: () => void
  onDelete: () => void
}) {
  const filingDate = priority.filingDate
    ? new Date(priority.filingDate).toLocaleDateString("en-GB")
    : null

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3.5 shadow-sm">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#e6edf5] text-dantzBlue">
          <FiFlag size={18} />
        </span>

        <div className="min-w-0 flex-1">
          <span className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
            Priority claim
          </span>

          <p className="mt-0.5 truncate text-sm font-medium text-gray-800">
            {priority.office || "Country"}
          </p>

          <p className="truncate text-xs text-gray-600">
            {priority.filingNumber || "-"}
            {filingDate ? ` · ${filingDate}` : ""}
          </p>

          <div className="mt-2.5 flex gap-4 border-t border-gray-100 pt-2.5">
            <button
              type="button"
              onClick={onEdit}
              className="inline-flex items-center gap-1 text-xs font-medium text-dantzBlue hover:underline"
            >
              <FiEdit2 size={13} /> Edit
            </button>

            <button
              type="button"
              onClick={onDelete}
              className="inline-flex items-center gap-1 text-xs font-medium text-red-600 hover:underline"
            >
              <FiTrash2 size={13} /> Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
